function volcano_layer(layer_name, file_name){
	var result = null;
	var scriptUrl = 'geojson/volcano/' + file_name;
	var data;
	if (raw_data[layer_name] == undefined) {
		data = ajax_call(scriptUrl);
	} else {
		data = raw_data[layer_name];
	}
    var collection = []
    var geojson = ajax_call(scriptUrl)
    Object.values(geojson).forEach(eachLayer => {
        collection.push(eachLayer)
    })
	var layer = L.geoJSON(turf.featureCollection(collection),{
        style: function(feature){
            if (!feature.properties.id && !feature.properties.ID) {
                return {
                    fillColor: 'red',
                    fillOpacity: .7,
                    weight: 0,
                    interactive: false
                }
            }
            if (feature.properties.id) {
                return {
                    fillColor: '#8B4513',
                    fillOpacity: .7,
                    weight: 0,
                    interactive: false
                }
            }
            if (feature.properties.category) {
                console.log(feature.properties.category)
                if (feature.properties.category === '夏天') {
                    return {
                        color: 'yellow',
                        interactive: false
                    }
                } else {
                    return {
                        color: 'blue',
                        interactive: false
                    }
                }
            }
        }
    });
	result = [layer, data];
	return result;
}
